export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const UPDATE_CART_ITEM = 'UPDATE_CART_ITEM';
export const UPDATE_QUANTITY = 'UPDATE_QUANTITY';
export const UPDATE_TOTAL_PRICE = 'UPDATE_TOTAL_PRICE';

